import apiClient from './client';
import {
  BASE_ENDPOINTS,
  RESOURCES,
  SERVICES,
  VERSIONS
} from './common/constants';

// Service endpoint mapping
const SERVICE_ENDPOINTS = {
  [SERVICES.TRACEABILITY]: BASE_ENDPOINTS.createEndpoint(
    SERVICES.TRACEABILITY,
    VERSIONS.V1,
    null,
    false
  ),
  [SERVICES.DIGITIZATION]: BASE_ENDPOINTS.createEndpoint(
    SERVICES.DIGITIZATION,
    VERSIONS.V1,
    null,
    false
  ),
  [SERVICES.TRANSFER]: BASE_ENDPOINTS.createEndpoint(
    SERVICES.TRANSFER,
    VERSIONS.V1,
    null,
    false
  ),
  [SERVICES.MANAGEMENT]: BASE_ENDPOINTS.createEndpoint(
    SERVICES.MANAGEMENT,
    VERSIONS.V1,
    null,
    false
  )
};

const DEFAULT_SERVICE = SERVICES.TRACEABILITY;

// Get service URL
const getServiceURL = service => {
  return SERVICE_ENDPOINTS[service];
};

// Transform dropdown options
const transformDropdownOptions = (dropdownOptions, selectedValues) => {
  const finalPayload = {};
  Object.keys(dropdownOptions).forEach(key => {
    finalPayload[key] =
      selectedValues[key] && selectedValues[key].length > 0
        ? selectedValues[key]
        : [];
  });
  return finalPayload;
};

// Main dynamic report function
export const getDynamicReportdata = async ({
  apiPath,
  cursor,
  limit,
  tenant,
  filter,
  service,
  dropdownOptions = [],
  selectedValues = {},
  payloadmode
}) => {
  const url = `${getServiceURL(service)}${apiPath}`;

  const dropdownPayload = transformDropdownOptions(
    dropdownOptions,
    selectedValues
  );

  let payload = {};
  if (payloadmode === 'flat') {
    payload = {
      cursor,
      limit,
      search_text: filter.search_text,
      ...dropdownPayload
    };
  } else {
    payload = {
      cursor,
      limit,
      filters: filter,
      ...dropdownPayload
    };
  }

  const data = await apiClient.post(url, payload);
  return data;
};

// Dynamic collapse report
export const getdynamicCollapseReport = async ({
  cursor,
  limit,
  tenant,
  startDate,
  endDate,
  apiPath,
  service,
  search_text
}) => {
  const url = `${getServiceURL(service)}${apiPath}`;

  const data = await apiClient.post(url, {
    cursor: cursor,
    limit: limit,
    filters: {
      start_date: startDate,
      end_date: endDate,
      search_text: search_text
    }
  });
  return data;
};

// Weather report data
export const getDynamicReportdataForWeather = ({
  district_ids,
  apiPath,
  cursor,
  limit,
  tenant,
  filter,
  service
}) => {
  const url = `${getServiceURL(service)}${apiPath}`;

  return apiClient.post(url, {
    district_ids,
    cursor,
    limit,
    search_text: filter.search_text
  });
};

// Dropdown filter data
export const getDropdownFilterData = ({ apiPath, service }) => {
  const url = `${getServiceURL(service)}${apiPath}`;
  return apiClient.get(url);
};
